module.exports = __webpack_public_path__ + "static/How-to-manage-tabs-21-e1403552946314-a197b4a745f7f9cb2ca3d57f634582f0.jpg";